import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer__contact" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "app-footer__title" }, " Wir sind für dich da ", -1)
const _hoisted_3 = { class: "icon-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "tel:+49410299740",
    target: "_blank"
  }, "04102 9974-0")
], -1)
const _hoisted_5 = { class: "icon-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:info@stadtwerke-ahrensburg.de",
    target: "_blank"
  }, "info@stadtwerke-ahrensburg.de")
], -1)

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPhone,
  faFax,
  faPaperPlane,
} from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooterContact',
  setup(__props) {

library.add(faPhone, faFax, faPaperPlane);

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_FontAwesomeIcon, { icon: _unref(faPhone) }, null, 8, ["icon"])
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode(_component_FontAwesomeIcon, { icon: _unref(faPaperPlane) }, null, 8, ["icon"])
      ]),
      _hoisted_6
    ])
  ]))
}
}

})